<template>
  <div>
    <div class="top">
      <div class="top-center w-1440 d-flex j-sb">
        <div class="left f-size-12"><span>AI食育师</span>｜<span>帮助中心</span></div>
        <el-dropdown v-if="$store.state.loginState" @command="handleCommand">
          <div class="el-dropdown-link crr d-flex a-center">
            <img class="crr" :src="$utils.baseURL + $store.state.userInfo.avatar" alt="" v-if="$store.state.userInfo.avatar">
            <template v-else>
              <img src="@/assets/img/nv.png" alt="" v-if="$store.state.userInfo.gender == 'FEMALE'">
              <img src="@/assets/img/nan.png" alt="" v-else-if="$store.state.userInfo.gender == 'MALE'">
            </template>
            {{$store.state.userInfo?.name}}<i class="el-icon-caret-bottom el-icon--right"></i>
          </div>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item command="1">
              <div class="d-flex a-center">
                <img src="@/assets/img/role.png" alt="" style="width: 16px;height: 16px;">
                <span style="margin-left: 4px;">切换角色</span>
              </div>
            </el-dropdown-item>
            <el-dropdown-item command="2">
              <div class="d-flex a-center">
                <img src="@/assets/img/exit.png" alt="" style="width: 16px;height: 16px;">
                <span style="margin-left: 4px;">退出登录</span>
              </div>
            </el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
        <div v-else class="login-wrapper">
            <div class="login f-size-14 crr" @click="showLoginTip" >登录</div>
            <div class="login f-size-14 crr" style="margin-left: 16px;" @click="showRegisterTip" >注册</div>
        </div>
        
      </div>
    </div>
    <div class="title d-flex a-center">
      <div class="title-center w-1440 d-flex a-center">
        <div class="d-flex a-center crr" @click="toPath('/home')">
          <img src="../../assets/img/nav-logo.png"  class="logo" />
          <p class="name color-f">AI食育师</p>
        </div>
        <div class="tabs crr"
          :class="{active: ishave('/home')}"
          @click="toPath('/home')"
          >
          首页
        </div>
        <div class="tabs crr"
          :class="{active: ishave('/news')}">
          <el-dropdown @command="commandHandle1">
            <span class="el-dropdown-link1" :class="{active: ishave('/news')}">
              新闻资讯<i class="el-icon-arrow-down el-icon--right"></i>
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item command="1">最新资讯</el-dropdown-item>
              <el-dropdown-item command="2">安全报道</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
        <div class="tabs crr"
          :class="{active: ishave('/course')}">
          <el-dropdown @command="commandHandle3">
            <span class="el-dropdown-link1" :class="{active: ishave('/course')}">
              课程中心<i class="el-icon-arrow-down el-icon--right"></i>
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item command="1">学习计划</el-dropdown-item>
              <el-dropdown-item command="2">在线课程</el-dropdown-item>
              <el-dropdown-item command="3">实践课程</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
        <div class="tabs crr"
          :class="{active: ishave('/food')}"
          @click="toPath('/food')"
          >
          带量食谱
        </div>
        <div class="tabs crr"
          @click="toAi()"
          >
          健康问答
        </div>
        <div class="tabs crr"
          :class="{active: ishave('/health')}"
          @click="toPath('/health')"
          >
          健康管理
        </div>
        <div class="tabs crr"
          :class="{active: ishave('/file')}"
          >
          <el-dropdown @command="commandHandle2">
            <span class="el-dropdown-link1" :class="{active: ishave('/file')}">
              资源下载<i class="el-icon-arrow-down el-icon--right"></i>
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item command="1">政策文件</el-dropdown-item>
              <el-dropdown-item command="2">其他资源</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data () {
    return {
    }
  },
  methods: {
    ishave(str2) {
      if(this.$route.path.indexOf(str2) === -1){
        return false
      }else{
        return true
      }
    },
    toPath(path) {
      if(this.$route.path == path){
        this.$router.go(0)
        return
      }
      if (['/health'].includes(path)) {
        if (!this.$store.state.loginState) {
          this.showLoginTip()
        } else {
          this.$router.push(path)
        }
      } else {
        this.$router.push(path)
      }
    },
    toAi() {
      const href = 'https://ai.aifoodedu.com/chat/9d988231b8ace06e'
      window.open(href, '_blank');
    },
    commandHandle1(command) {
      if (command == 1) {
        // this.toPath('/news?type=1')
        window.location.href = '/news?type=1';
      } else if (command == 2) {
        // this.toPath('/news?type=2')
        window.location.href = '/news?type=2';
      }
    },
    commandHandle2(command) {
      if (command == 1) {
        this.toPath('/file')
      } else if (command == 2) {
        this.toPath('/resource')
      }
    },
    commandHandle3(command) {
      if (command == 1) {
        // this.toPath('/course?courseType=1')
        window.location.href = '/course?courseType=1';
      } else if (command == 2) {
        // this.toPath('/course?courseType=2')
        window.location.href = '/course?courseType=2';
      } else if (command == 3) {
        // this.toPath('/course?courseType=3')
        window.location.href = '/course?courseType=3';
      }
    },
    showLoginTip() {
      this.$store.commit('setLoginTip', true)
    },
    showRegisterTip() {
      this.$store.commit('setRegisterTip', true)
    },
    handleCommand(command) {
      if (command == 1) {
        this.$store.commit('setChangeRole',true)
      } else if (command == 2) {
        this.logout()
      }
    },
    logout() {
      this.$api.login.exitLogin().then(res => {
        this.$store.commit('exitLogin')
        if (this.$route.path !== '/home') {
          this.$router.replace('/home')
        }
        setTimeout(()=>{
          this.$message.success('已退出登录！')
        }, 30)
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.top{
  background: #FAFAFC;
  .top-center{
    padding: 5px 0;
  }
}
.el-dropdown-link{
  img{
    width: 24px;
    height: 24px;
    border-radius: 50%;
    margin-right: 6px;
  }
}
.el-dropdown-link1{
  color: #fff;
  font-size: 18px;
  font-weight: 550;
}
.login-wrapper {
  display: flex;
}
.title{
  background: #03B355;
  height: 64px;
  .title-center{
    .logo{
      width: 48px;
    }
    .name{
      font-size: 26px;
      margin: 0 40px 0 10px;
    }
    .tabs{
      margin: 0 20px;
      padding: 4px 10px;
      border-radius: 4px;
      color: #fff;
      font-size: 18px;
      font-weight: 550;
      &:hover{
        background: #FFC120;
        color: #03B355;
      }
    }
    .active{
      background: #FFC120;
      color: #03B355;
    }
  }
}
</style>
